import client from './client';

export interface Event {
  id: number;
  title_kk: string;
  title_ru: string;
  description_kk?: string;
  description_ru?: string;
  image_url?: string;
  location_name?: string;
  address?: string;
  start_date: string;
  end_date?: string;
  category: 'concert' | 'sport' | 'holiday' | 'exhibition' | 'workshop' | 'kids' | 'other';
  organizer?: string;
  price?: number;
  is_free: boolean;
  max_participants?: number;
  registered_count: number;
  is_active: boolean;
  created_at: string;
}

export interface EventCreatePayload {
  title_kk: string;
  title_ru: string;
  description_kk?: string;
  description_ru?: string;
  image_url?: string;
  location_name?: string;
  address?: string;
  start_date: string;
  end_date?: string;
  category: string;
  organizer?: string;
  price?: number;
  is_free: boolean;
  max_participants?: number;
}

export interface EventStats {
  total_events: number;
  upcoming: number;
  total_registrations: number;
}

export const eventsApi = {
  list: (params?: Record<string, any>) =>
    client.get<Event[]>('/api/admin/events', { params }),

  create: (data: EventCreatePayload) =>
    client.post('/api/admin/events', data),

  update: (id: number, data: Partial<EventCreatePayload>) =>
    client.patch(`/api/admin/events/${id}`, data),

  delete: (id: number) =>
    client.delete(`/api/admin/events/${id}`),

  stats: () =>
    client.get<EventStats>('/api/admin/events/stats'),
};
